import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/Blogclassic/Content';

class Blogclassic extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | Blog</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'News'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default Blogclassic;